@if (customers$ | async; as customers) {
  <div class="select-recipient-container">
    <div class="user-selector">
      @if (customers?.length > 0) {
        <glxy-form-field class="user-selector-input">
          <glxy-label>
            {{ 'LIB_ORDERS.SALES_ORDERS.SUBMIT_ORDER_FOR_APPROVAL.SELECT_FOR_ASSOCIATION' | translate }}
          </glxy-label>
          <mat-select [formControl]="customersControl" required [compareWith]="compareCustomer">
            @for (customer of customers; track customer.email) {
              <mat-option [value]="customer">
                <ng-container *ngTemplateOutlet="userOption; context: { $implicit: customer }"></ng-container>
              </mat-option>
            }
            <mat-select-trigger>
              <ng-container
                *ngTemplateOutlet="userOption; context: { $implicit: customersControl.value }"
              ></ng-container>
            </mat-select-trigger>
          </mat-select>
          @if (isCustomerControlInvalid$ | async) {
            <glxy-error>
              {{ 'LIB_ORDERS.SALES_ORDERS.SUBMIT_ORDER_FOR_APPROVAL.CONTACT_REQUIRES_EMAIL' | translate }}
            </glxy-error>
          }
        </glxy-form-field>
      } @else {
        <glxy-form-field class="user-selector-input">
          <glxy-label>
            {{ 'LIB_ORDERS.SALES_ORDERS.SUBMIT_ORDER_FOR_APPROVAL.SELECT_FOR_ASSOCIATION' | translate }}
          </glxy-label>
          <mat-select
            disabled="true"
            [placeholder]="'LIB_ORDERS.SALES_ORDERS.SUBMIT_ORDER_FOR_APPROVAL.NO_ASSOCIATIONS' | translate"
          ></mat-select>
        </glxy-form-field>
      }
    </div>
    <div
      class="associate-user-button associate-user-button-spacing"
      [ngClass]="{
        'associate-user-button-error': isCustomerControlInvalid$ | async,
        'associate-user-button-spacing': customers?.length > 0,
        'associate-user-button-empty-spacing': customers?.length === 0,
      }"
    >
      <button mat-stroked-button (click)="addCRMContact()">
        {{ 'LIB_ORDERS.SALES_ORDERS.SUBMIT_ORDER_FOR_APPROVAL.ASSOCIATE' | translate }}
      </button>
    </div>
  </div>
} @else {
  <div class="stencil-shimmer loading"></div>
}

<ng-template #userOption let-customer>
  @if (customer) {
    <div class="option-row">
      {{ customer.firstName }} {{ customer.lastName }}
      @if (customer.email) {
        <span>({{ customer.email }})</span>
      }
    </div>
  }
</ng-template>
